import { combineReducers } from 'redux';

import { loginReducer } from '../components/account/Login/ducks/reducer';
import { confirmReducer } from '../components/account/Confirm/ducks/reducer';
import { paystubReducer } from '../components/Paystubs/ducks/reducer';
import { taxDocumentReducer } from '../components/TaxDocuments/ducks/reducer';
import { profileReducer } from '../components/account/Profile/ducks/reducer';
import { forgotUsernameReducer } from '../components/account/ForgotUsername/ducks/reducer';
import { forgotPasswordReducer } from '../components/account/ForgotPassword/ducks/reducer';
import { resetPasswordReducer } from '../components/account/ResetPassword/ducks/reducer';
import { updateEmailReducer } from '../components/account/UpdateEmail/ducks/reducer';
import { updatePasswordReducer } from '../components/account/UpdatePassword/ducks/reducer';
import { confirmNewEmailReducer } from '../components/account/ConfirmNewEmail/ducks/reducer';
import { navReducer } from '../components/common/Nav/ducks/reducer';
const rootReducer = combineReducers({
  loginReducer,
  confirmReducer,
  paystubReducer,
  taxDocumentReducer,
  forgotUsernameReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  profileReducer,
  updateEmailReducer,
  updatePasswordReducer,
  confirmNewEmailReducer,
  navReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js